'use strict';

// Require optional shared components
require(['componentLoader'], function (helper) {
  // This site's module parameters
  helper.updateConfig({
    ajaxBasket: {
      excludeTick: true,
      recommendationsParentClass: 'recommendations-section',
      recommendationsHeaderClass: 'heading',
      recommendationsClass: 'item',
      recommendationsHeaderEncloseElement: 'h3',
      maxRecommendations: 4,
      thumbnailImageSize: 'large'
    },
    imageZoom: {
      bx_mode: 'horizontal',
      bx_controls: false,
      bx_pause: 4000,
      bx_infiniteLoop: false,
      bx_displaySlideQty: 4,
      bx_moveSlideQty: 4,
      bx_startingSlide: 0,
      bx_slideWidth: 150,
      bx_hideControlOnEnd: false,
      productArea: '.product-image-col .media',
      thumbnailSelector: '.product-image-col .product-thumbnails'
    },
    quickView: {
      width: 1100,
      minHeight: 320
    },
    siteSliderDefaults: {
      sliderSet: {
        arrowsNav: false
      }
    }
  });

  // Make these modules dependencies
  helper.promote(['brandsSelection', 'countrySwitcher', 'cCarousel', 'countdown', 'CurrencySelection', 'editorialVideoScript']);

  // Add new shims
  helper.updateShim({
    facetTpl: {
      deps: ['handlebars'],
      exports: 'facetUpdateTpl'
    }
  });

  helper.requireDependencies();
});

define(['jquery', 'siteObj', 'common', 'expander', 'fancyBox', 'hint', 'royalslider', 'popup'], function ($, siteObj) {
  var _beint = {

    _initCountdown: function _initCountdown() {
      //Countdown Timer
      if (siteObj.customerLocation === 'GB') {
        if ($('.countdown-timer-product,.countdown-timer-widget').length) {
          require(['dispatchCountdown'], function (c) {
            c.initDispatchCountdown();
          });
        }
      }
    },

    _initBannerWidgetLinks: function _initBannerWidgetLinks($bannerLinks) {
      //for putting links inside widget banners
      $bannerLinks.find('.btn[data-href], .data-link[data-href], .product-sku-link[data-href]').click(function () {
        window.location = $(this).attr('data-href');
        return false;
      });
    },

    _initCurrencySelector: function _initCurrencySelector() {
      //Currency Selector Behaviours
      require(['CurrencySelection'], function (CurrencySelection) {
        window.cSelect = new CurrencySelection('li.currency');
      });
    },

    _initProductImageFancyBox: function _initProductImageFancyBox() {
      //load product image in fancybox
      $('.fb-zoom').fancybox({
        'margin': 50,
        'padding': 5,
        'arrows': false
      });
    },

    _initFancyBoxDefaults: function _initFancyBoxDefaults() {
      $.fancybox.defaults = $.extend($.fancybox.defaults, {
        'height': 'autoSize',
        'width': 1010,
        'minWidth': 350,
        'maxWidth': 1010,
        'minHeight': 200,
        'margin': 0,
        'padding': 15,
        'overflow': 'visible'
      });
    },

    _initProductPage: function _initProductPage($reviewStars, $customerReviews) {
      if (siteObj.type === 'product') {

        var $productBrandLogo = $('.product-brand-logo');
        var $brandLogoImage = $productBrandLogo.find('.product-logo-img');
        var $img = document.createElement('img');

        $img.onload = function () {
          $productBrandLogo.addClass('visible');
        };
        $img.src = $brandLogoImage.attr('src');

        var $variationDropDowns = $('.variation-dropdowns');
        if ($variationDropDowns.length > 0 && $('#opts-4').length > 0 && $('ul.colour-swatches-list').length < 1 || $variationDropDowns.length > 0 && $('#opts-2').length > 0) {
          require(['colourswatches'], function (colourswatches) {
            colourswatches.colourSwatchesForSelectBoxWithLabel('opts-4');
            window.colourPicker();
          });
        }

        // Enables page scrolling to an id on
        $reviewStars.click(function () {
          $('html, body').animate({
            scrollTop: $customerReviews.offset().top - 20
          }, 750);
        });

        // product page PAP popup
        var $promoDesc = $('.product-promo .product-promo-desc');
        var $promo = $promoDesc.length ? $promoDesc.parent() : false;

        if ($promo) {
          $promo.find('h3').css('cursor', 'pointer').click(function () {
            var html = $promo.wrap('<div />').parent().html();

            $.fancybox(html, {
              'width': 400,
              'maxWidth': 400,
              'height': 'auto'
            });
          });
        }
      }
    },

    _initVariationsOnListPages: function _initVariationsOnListPages($body, initial_fb_content) {
      // Handle list page variations products.
      if ($body.hasClass('list') || $body.hasClass('dept') || $body.hasClass('searchlist') || $body.hasClass('product')) {
        $body.on('click', '.quickview, .quickview-buy', function () {

          var contents = void 0;
          var page_url = $(this).attr('href');
          var product_id = $(this).closest('.item').attr('rel');
          var basket_utils = siteObj.fn.basket;
          var fb_opts = {
            afterShow: function afterShow() {
              // Bind close events
              $('.product-quick-view').delegate('.close-fb', 'click', function (e) {
                $.fancybox.close();
                e.preventDefault();
              });
            },
            beforeClose: function beforeClose() {
              $('.product-quick-view').undelegate('.close-fb');
            }
          };

          siteObj.productID = product_id;

          if ($().fancybox) {
            $.fancybox(initial_fb_content, $.extend({
              'closeBtn': false
            }, fb_opts));
          }

          $.ajax({
            url: page_url,
            cache: false,
            data: 'ajax=true',
            dataType: 'html',
            success: function success(result) {
              contents = window.quickView(result, page_url);
              $.fancybox.close();
              $.fancybox(contents, $.extend({
                'closeBtn': false
              }, fb_opts));

              $('.fancybox-inner').fadeIn('400', function () {

                $(this).find('.productoptions');

                if ($('input[name=\'cheapest-product-id\']').length) {
                  basket_utils.preselected_product = true;
                }
                $('.buying-area button[disabled=\'disabled\']').removeAttr('disabled').addClass('disabled');
              });
            }
          });
          return false;
        });
      }
    },

    _initHelpSitePopup: function _initHelpSitePopup() {
      // help site pop up
      $('a[href^=\'http://help.beautyexpert.co.uk\'],a[href^=\'http://help.beautyexpert.com\']').click(function (e) {
        // set up new window options
        // set up new window options
        var helpurl = $(this).attr('href');

        // check if there are query string parameters in the link already
        if (helpurl.indexOf('?') === -1) {
          helpurl += '?';
        } else {
          helpurl += '&';
        }

        if (siteObj.customerLocale === 'en_US') {
          // lang and locale value for overriding 2 digit locals
          helpurl += 'lang=' + siteObj.selectedLang + '-' + siteObj.countryCode;
        } else {
          // lang value only
          helpurl += 'lang=' + siteObj.selectedLang;
        }
        window.open(helpurl, '', 'height=800,scrollbars=yes,width=785', false);
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
      });
    },

    _initTooltipPopups: function _initTooltipPopups() {
      //initialize tooltip  popups
      if ($().popover) {
        $('.lbl-help').popover({
          trigger: 'manual'
        }).hover(function () {
          //trigger the popover manually to allow us to set a timer to keep it open
          $('.lbl-help').popover('hide'); // hide all open popups
          $(this).popover('show'); //show current one
        }).mouseleave(function () {
          setTimeout('$(\'.popover\').hide()', 2000); //hide popup after 2 seconds
        });
      }
    },

    _initReadMore: function _initReadMore($body) {
      // Read more expand text for department & list pages
      if ($body.is('.dept, .list, .product') && $('div').hasClass('expand-text')) {

        $('.expand-text p, .expand-text span').css('visibility', 'visible'); // To stop the jerky motion when the page is loaded

        $('.expand-text').expander({
          slicePoint: 400,
          preserveWords: true,
          widow: 4,
          expandEffect: 'fadeIn',
          expandSpeed: 400,
          collapseEffect: 'fadeOut',
          collapseSpeed: 400,
          collapseTimer: 0,
          expandPrefix: ''
        });

        // opens product page description when clicking read more on quickview.

        if (siteObj.type === 'product' && window.location.hash === '#productOverview') {
          var $readMore = $('.product-info .read-more a');
          $readMore.click();
        }
      }
    },

    _initListSortDropdown: function _initListSortDropdown($listSort) {
      //handle list sort dropdown
      if (!$('.facets-panel').length) {
        $listSort.change(function () {
          var $this = $(this);
          $this.parents('form:first').submit();
        });
      }
    },

    _initFancyBox: function _initFancyBox() {
      //todo what is this?
      if ($().fancybox) {
        var $question = $('.question');
        var $fbClose = $('.fb-close');
        var $selector = $('.fb');
        var $onLoadSelector = $('.fb-onload');
        var content = '';
        var fancybox_opts = {
          'closeBtn': false,
          'init': function init($this, markup) {
            if (markup === true) {
              content = $this.html();
            }
            $this.fancybox({
              'content': content,
              'onComplete': function onComplete() {
                fancybox_opts.events();
              },
              'afterShow': function afterShow() {
                fancybox_opts.events();
              },
              'onClosed': function onClosed() {
                fancybox_opts.cleanup();
              }
            });
          },
          'events': function events() {
            $fbClose.on('click', function (e) {
              e.preventDefault();
              $.fancybox.close(true);
            });
          },
          'cleanup': function cleanup() {
            $question.find('[data-answer]').unbind('click');
          }
        };

        fancybox_opts.init($selector);
        fancybox_opts.init($onLoadSelector, true);
        $onLoadSelector.click();
      }
    },

    _initAccountCreationScript: function _initAccountCreationScript() {
      // account creation page script
      if (siteObj.page === 'account-creation') {
        require(['accountCreate']);
      }
    },

    _initAnchorScrollScript: function _initAnchorScrollScript() {
      if (siteObj.sectionName !== 'brands') {
        require(['anchorScroll']);
      }
    },

    _initLoginPageScript: function _initLoginPageScript() {
      // login page scripts
      if (siteObj.page === 'login') {
        require(['loginPage']);
      }
    },

    _initReviewPagingScript: function _initReviewPagingScript() {
      // Review Paging
      if (siteObj.type === 'product') {
        require(['reviewPaging']);
      }
    },

    _initLivePersonScript: function _initLivePersonScript() {
      // Liveperson
      if (siteObj.props.testApps.lp === true) {
        require(['livePerson']);
      }
    },

    _initGandalfScript: function _initGandalfScript() {
      // Gandalf
      if (siteObj.features.projectGandalf.active === true) {

        if (siteObj.sectionName === 'contact-us' || siteObj.page === 'contact-us') {
          require(['mvtBSContactP1']);
        }

        if (siteObj.page === 'customer-service') {
          require(['mvtBSContactP2']);
        }
      }

      if (siteObj.sectionName === 'customer-service') {
        require(['faq']);
      }
    },

    _init: function _init() {

      var $body = $('body');
      // Initial HTML markup to be added into Fancybox. Contains the loading spinner and hidden close button.
      var initial_fb_content = '<div class="basketAlert"><img src="' + siteObj.siteNonSecureURL + 'common/images/loading.gif" alt="Loading" class="fb-loader" /></div>';
      var $listSort = $('.list-sort select');
      var $reviewStars = $('.has-reviews .link');
      var $customerReviews = $('#customer-reviews');
      var $bannerLinks = $('.media-block');

      _beint._initCountdown();

      _beint._initBannerWidgetLinks($bannerLinks);

      _beint._initCurrencySelector();

      _beint._initProductImageFancyBox();

      _beint._initVariationsOnListPages($body, initial_fb_content);

      _beint._initFancyBoxDefaults();

      _beint._initProductPage($reviewStars, $customerReviews);

      _beint._initReadMore($body);

      _beint._initListSortDropdown($listSort);

      _beint._initHelpSitePopup();

      _beint._initTooltipPopups();

      _beint._initFancyBox();

      _beint._initAccountCreationScript();

      _beint._initAnchorScrollScript();

      _beint._initLoginPageScript();

      _beint._initReviewPagingScript();

      _beint._initLivePersonScript();

      _beint._initGandalfScript();

      /* Javascript Healthcheck - Please keep this at the bottom of the file. */
      var healthCheck = document.createElement('span');
      healthCheck.id = 'jshealthcheck';
      document.body.appendChild(healthCheck);
    }
  };

  _beint._init();
  return _beint;
});
//# sourceMappingURL=beint.js.map
